import { useEffect, useState } from 'react'
import { DEFAULT_TRIAL_DAYS, getStoredReferralCode } from '../../utils/referral'
import { fetchReferralStatus } from '../../redux/actions/referralAction'

/**
 * The trial length to promise on a trial screen: 14 days for a referred friend the server says
 * qualifies, 5 for everyone else. Starts at 5 and only moves up once the server confirms, so the
 * page never promises a longer trial than the checkout will grant. Skips the call entirely for
 * visitors who never came through a referral link on this device.
 */
export function useTrialDays(): number {
  const [days, setDays] = useState(DEFAULT_TRIAL_DAYS)
  useEffect(() => {
    if (!getStoredReferralCode()) return
    let alive = true
    fetchReferralStatus().then((status) => {
      if (alive && status?.trialDays) setDays(status.trialDays)
    })
    return () => {
      alive = false
    }
  }, [])
  return days
}
